import { createFileRoute } from '@tanstack/react-router';

import { InvoiceCheckSettings } from '~/modules/invoiceCheckSettings/InvoiceCheckSettings';
import { LoadingPage } from '~/modules/router/components';

import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';

import { routeParams } from './-routeParams';

export const Route = createFileRoute('/(main)/settings/invoice-check/')({
  beforeLoad: createProtectedRoute({
    routePath: '/settings/invoice-check/',
    ...routeParams,
  }),
  component: InvoiceCheckSettings,
  pendingComponent: LoadingPage,
  wrapInSuspense: true,
});

export const SETTINGS_INVOICE_CHECK = buildRouteExport({
  Route,
  ...routeParams,
});
